import axios from "axios";
import { getApiUrl } from "../config/api.js";

export const call = async (method, url, params, body, callback) => {
  try {
    console.log("call", url);
    const { data } = await axios({
      method,
      url: getApiUrl(url),
      data: body,
      params,
    });

    if (typeof callback === "function") {
      return callback(data);
    }

    return data;
  } catch (err) {
    err.error = err?.response?.data?.errors?.error?.[0];

    throw err;
  }
};

export const get = (url, params, callback) =>
  call("get", url, params, undefined, callback);

export const post = (url, data, callback) =>
  call("post", url, undefined, data, callback);

export const put = (url, data, callback) =>
  call("put", url, undefined, data, callback);

export default {
  get,
  post,
  put,
};
